import { useGetHorariosLojaQuery, useGetLojaAtualQuery } from '../api'
import { agendamentoOfertavel, antecedenciaAgendamentoMin, gerarDiasAgendaveis, proximaAbertura, type ProximaAbertura } from '../lib/agendamento'

export interface LojaFechadaDelivery {
  aberta: boolean
  ofertavel: boolean
  proxima: ProximaAbertura | null
}

/** Mesma regra e mesmas entradas do checkout; `null` até os dados chegarem e fora do delivery, que não agenda. */
export function useLojaFechadaDelivery(): LojaFechadaDelivery | null {
  const { data: horariosResp } = useGetHorariosLojaQuery(undefined, { pollingInterval: 5 * 60_000 })
  const { data: loja } = useGetLojaAtualQuery()

  if (!horariosResp || !loja || loja.identificador.tipo !== 'DELIVERY') return null

  const agora = new Date()
  const { agendamentoDelivery, tempoMaxPreparo } = loja.configuracao
  const dias = gerarDiasAgendaveis(horariosResp.horarios, agora, { leadMin: antecedenciaAgendamentoMin(tempoMaxPreparo) })

  return {
    aberta: horariosResp.aberta,
    ofertavel: agendamentoOfertavel({ modo: agendamentoDelivery, lojaFechada: !horariosResp.aberta, temDiaAgendavel: dias.length > 0 }),
    proxima: proximaAbertura(horariosResp.horarios, agora),
  }
}
